import React from 'react';
import { Dialog, Typography, DialogActions, DialogContent } from '@mui/material';
import CommonModalHeader from '../../../../../components/DialogUi/CommonModalHeader';
import DosenButton from '../../../../../components/ui/Buttons/DosenButton';

interface Props {
  openDelete: boolean;
  setDelete: any;
  deleteLoader: boolean;
  handleDelete: any;
  text: string;
  btnText?: string;
  // Label shown while the action runs, e.g. "Removing...".
  loadingText?: string;
}

const ProgramDeletDialog = ({
  openDelete,
  setDelete,
  deleteLoader,
  handleDelete,
  text,
  btnText = 'Remove',
  loadingText = 'Removing...'
}: Props) => {
  const closeModal = () => {
    if (deleteLoader) return;
    setDelete(false);
  };
  return (
    <Dialog
      open={openDelete}
      onClose={closeModal}
      fullWidth
      scroll="body"
      disableEnforceFocus
      PaperProps={{
        sx: { backgroundColor: '#1A1A1A', color: '#FDFDFD', border: '1px solid #2A2A2A', borderRadius: '12px' }
      }}
    >
      <CommonModalHeader title="Confirmation" handleCloseModal={closeModal} />
      <DialogContent sx={{ backgroundColor: '#1A1A1A', color: '#FDFDFD' }}>
        <Typography variant="h5" textAlign="center" color="inherit">
          {text}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: '#1A1A1A', gap: 1, px: 2, pb: 2 }}>
        <DosenButton fullWidth tone="basic" onClick={closeModal} disabled={deleteLoader}>
          Cancel
        </DosenButton>
        <DosenButton fullWidth tone="cta" loading={deleteLoader} loadingText={loadingText} onClick={handleDelete}>
          {btnText}
        </DosenButton>
      </DialogActions>
    </Dialog>
  );
};

export default ProgramDeletDialog;
